import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Sidebar from './Sidebar';

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login'); // Redirect to login if no user is logged in
    }
  }, [user, navigate]);

  if (!user) {
    return null; // Don't render anything while redirecting
  }

  // Sidebar renders its own mobile top bar (normal flow, md:hidden) and its
  // own desktop panel (fixed on mobile so it can slide in as an overlay,
  // position:static from md: up so it sits in-flow next to the content) - it
  // does not need to be duplicated/wrapped for each breakpoint. This used to
  // render <Sidebar /> twice (once forced hidden below md, once forced
  // hidden from md up), which put two of everything - including two
  // elements with the same aria-label - in the DOM at all times.
  // flex-col on mobile stacks the top bar above the content; md:flex-row
  // puts the (now in-flow) sidebar panel beside the content on desktop.
  return (
    <div className="flex flex-col md:flex-row h-screen overflow-hidden bg-slate-50">
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 bg-slate-50 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
